const graduation_list = {
  title: '卒業期管理',
  new: '追加',
  csv_upload: 'CSVアップロード',
  csv_template: 'CSVテンプレート',
  search_graduation_placeholder: '検索',
  id: '卒業期名',
  start_date: '募集開始',
  learning_start_date: '講座開始時期',
  coach_authority_available: '講座提供利用開始',
  start_date_charging: '課金開始',
  coach_payment_setting: 'コーチ・課金設定',
  created_date: '作成日',
  status: 'ステータス',
  status_active: '未公開',
  status_in_progress: '進行中',
  status_completed: '完了',
  modal: {
    change_status_public_to_draft: {
      title: '卒業期公開の確認',
      content:
        'ご指定の卒業期を非公開すると、登録フォームに表示しません。よろしいでしょうか。',
      cancel: 'いいえ',
      yes: 'はい',
    },
    change_status_draft_to_public: {
      title: '卒業期公開の確認',
      content:
        'ご指定の卒業期を公開すると、登録フォームに表示します。よろしいでしょうか。',
      cancel: 'いいえ',
      yes: 'はい',
    },
  },
  toast: {
    public_graduation_success: 'ご指定の卒業期を公開しました。',
    hide_graduation_success: 'ご指定の卒業期を非公開しました。',
  }
}

export default graduation_list;